import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// INTERFACES
import { IUnitOfMeasure } from '../../../unit-of-measure';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UnitOfMeasureApiService {
  private readonly _unitOfMeasures = new BehaviorSubject<any>(<any>{});
  private readonly _unitOfMeasuresByRfqId = new BehaviorSubject<{
    [key :string] :IUnitOfMeasure[];
  }>(<{ [key :string] :IUnitOfMeasure[] }>{});
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);

  unitOfMeasures$ = this._unitOfMeasures.asObservable();
  unitOfMeasuresByRfqId$ = this._unitOfMeasuresByRfqId.asObservable();
  loading$ = this._loading.asObservable();
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(data :{
    id :number;
    params ?:{ [param :string] :string | string[] };
  }) :Subscription {
    const { id, params = {} } = data;

    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV2}/uom/unit-of-measures`, { params })
      .subscribe({
        next: (response :any) => {
          this._unitOfMeasuresByRfqId.next({
            ...this._unitOfMeasuresByRfqId.value,
            [id]: response.data,
          });
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  searchByUnitClass(
    unitClassId :number,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/uom/unit-of-measures/${unitClassId}/search`,
      {
        params,
      },
    );
  }

  getAll(data :{ params ?:{ [param :string] :string | string[] } }) :Subscription {
    const { params = {} } = data;

    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV2}/uom/unit-of-measures`, { params })
      .subscribe({
        next: (response :any) => {
          this._unitOfMeasures.next(response);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getSpecificConversionRule(data :{
    params ?:{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { params } = data;

    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV2}/uom/unit-conversion-rules/specific`, {
        params,
      })
      .pipe(
        map((response :any) => {
          this._loading.next(false);

          return response;
        }),
        catchError((response) => {
          this._loading.next(false);

          return throwError(() => response.error);
        }),
      );
  }

  getV2(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/uom/unit-of-measures`, {
      params,
    });
  }

  getConversionRule(params ?:{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/uom/unit-conversion-rules/specific`,
      { params },
    );
  }
}
